import { get, post, put, del } from '../../api-config';
import { gdpService, getLocale } from './_service';

// Professionals (search & creation)
export const postPrefessionals = async (data: any) =>
  await post(gdpService, '/users/search', data, null);

export const postNewPrefessionals = async (data: any) =>
  await post(gdpService, '/users', data, null);

// Professional / user detail
export const getUserHistoric = async (data: any) =>
  await get(gdpService, `/users/${data.id}/historic`, null, null);

export const getUser = async (id: any) => await get(gdpService, `/users/${id}`, null, null);

export const putUser = (data: any) => put(gdpService, `/users`, data, null);

export const postUserPassword = (id: any, data: any) =>
  post(gdpService, `/users/${id}/password`, data, null);

// Acceso a la plataforma (bloqueo de profesionales).
// Endpoint aparte del PUT de la ficha a propósito: si fuese un campo más del usuario, cada guardado de la
// ficha lo reenviaría y acabaría reactivando a alguien sin querer.
export const getUserAccess = async (id: string) =>
  await get(gdpService, `/users/${id}/access`, null, null);

export const putUserAccess = async (id: string, data: any) =>
  await put(gdpService, `/users/${id}/access`, data, null);

// Classifier types
// Global / admin listing — ignores group, supports pagination.
export const getClassifierTypes = async (params: any) =>
  await get(gdpService, '/classifierTypes', null, { ...(params ?? {}), locale: getLocale() });

// Per-user options — filters by the user's group (with ancestor fallback).
// Use this for selectors that assign a classifier to a specific patient/professional.
export const getUserClassifierTypeOptions = async (userId: string, filter: string) =>
  await get(gdpService, `/users/${userId}/classifier-types/options`, null, {
    filter,
    locale: getLocale(),
  });

// User classifier
export const getUserClassifier = async (data: any, params: any) =>
  await get(gdpService, `/users/${data.userId}/classifier`, null, params);

export const getHistoricUserClassifier = async (data: any, params: any) =>
  await get(gdpService, `/users/${data.userId}/classifier/historic`, null, params);

export const addUserClassifier = async (data: any) =>
  await post(gdpService, `/users/${data.userId}/classifier`, data, null);

export const deleteUserClassifier = async (data: any) =>
  await del(gdpService, `/users/${data.userId}/classifier/${data.userClassifierId}`);

// Classifiers
export const getClassifiers = async (params: any) =>
  await get(gdpService, '/classifier', null, params);

// User settings
export const getUserSettings = () => get(gdpService, '/userSettings', null, null);

export const postUserSettings = (data: any) => post(gdpService, '/userSettings', data, null);

export const putUserSettings = (data: any) => put(gdpService, '/userSettings', data, null);
